import PropTypes from 'prop-types';
import React from 'react';

import { usePuppyData } from 'dpl/puppy_page/hooks/usePuppyData';
import {
  ANALYTICS_EVENTS,
  ANALYTICS_VIEW_FEATURES
} from 'dpl/constants/analytics';
import { SOCIAL_SHARE_TYPES } from 'dpl/shared/constants/social';
import { getSocialShareLink } from 'dpl/util/social';
import { sendRudderstackEvent } from 'dpl/util/analytics';

import ActionButton from '../ActionButton';

export default function ShareButton({ analytics, children, ...props }) {
  const { meta } = usePuppyData();

  function handleClick() {
    sendRudderstackEvent(ANALYTICS_EVENTS.BUTTON_CLICKED, {
      ...analytics,
      button_cta: 'share_icon',
      view_feature: ANALYTICS_VIEW_FEATURES.SHARE_ICON
    });

    if (window.navigator.share) {
      window.navigator.share({
        title: meta.page_title,
        text: meta.page_description,
        url: meta.page_url
      });
    } else {
      window.open(
        getSocialShareLink(
          SOCIAL_SHARE_TYPES.EMAIL,
          meta.page_url,
          meta.page_title
        )
      );
    }
  }

  return (
    <ActionButton {...props} iconName="fetch-share" onClick={handleClick}>
      {children}
    </ActionButton>
  );
}

ShareButton.propTypes = {
  analytics: PropTypes.shape({
    view: PropTypes.string,
    view_feature_location: PropTypes.string
  }),
  children: PropTypes.node
};

ShareButton.defaultProps = {
  analytics: {},
  children: null
};
